import './popup-review.ajscss';

import { IComponentController, IComponentOptions } from 'angular';

import { DisplayDeprecatedComponent } from '@contact/upgrade';

import templateUrl from './popup-review.html';

const MODULE_NAME = 'popupReview';

class PopupReviewCtrl extends DisplayDeprecatedComponent implements IComponentController {
  public name = MODULE_NAME;

  // binding
  public dismiss: Function;
  public resolve: Function;
  public eventCommentChange: Function;
  public validateFn: Function;

  // internal properties
  public param: any;
  public review: string;
  public valid: boolean;

  constructor() {
    super();
  }

  $onInit(): void {
    this.param = this.resolve();
  }

  validate(): void {
    this.param.validateFn(this.review);
    // close popin
    this.dismiss();
  }

  cancel(): void {
    this.dismiss();
  }

  onReviewChange({ review }): void {
    this.review = review;
    this.valid = !!this.review;
  }
}

export class PopupReview implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    resolve: '&',
    dismiss: '&',
  };
  controller = [PopupReviewCtrl];
}

export default MODULE_NAME;
